import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/page-layout.scss'
import hasPermi from './directive/hasPermi'

import axios from 'axios'

// 配置axios默认设置
axios.defaults.baseURL = '/api'
axios.defaults.timeout = 60000

// 请求拦截器 - 添加token
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器 - 处理错误
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      // token过期或无效，跳转到登录页
      localStorage.removeItem('token')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.directive('hasPermi', hasPermi)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')